module.exports = __webpack_public_path__ + "img/logo.3fea3d6e.png";